// Third-party
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import smoothscroll from 'smoothscroll-polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { IntlProvider } from 'react-intl-redux';
import { Provider } from 'react-redux';

import { ConnectedRouter } from 'connected-react-router';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// Containers
import App from './views/containers/App';

// Utils
import sentryUtils from './utils/3rd-party/sentry';
import ZendeskUtils from './utils/3rd-party/zendesk';
import highchartsUtils from './utils/3rd-party/highchartsUtils';
import IntlGlobalProvider from './utils/i18n';
import notification from './utils/notification';

// Redux
import api from './redux/redux-api';
import store, { history } from './redux/store';
import { sessionTimeout } from './redux/modules/auth';

// Components
import { CustomDragLayer } from './views/components/misc/drag-and-drop/CustomDragLayer';
import { HtmlLangSync } from './views/components/HtmlLangSync';

// Style
import 'react-perfect-scrollbar/dist/css/styles.css';
import './index.scss';

// Hicharts Accessibility
import Highcharts from 'highcharts';
import HighStock from 'highcharts/highstock';
import highchartsAccessibility from 'highcharts/modules/accessibility';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';
import { Toaster } from '@capintel/component-lib/toast';

// Initialize modules
Exporting(Highcharts);
ExportData(Highcharts);
highchartsAccessibility(Highcharts);
Exporting(HighStock);
ExportData(HighStock);
highchartsAccessibility(HighStock);

// Set global HighStock options
HighStock.setOptions({
  exporting: {
    enabled: false,
    showTable: false,
  },
});

// Set global Highcharts options
Highcharts.setOptions({
  exporting: {
    enabled: false,
    showTable: false,
  },
});

smoothscroll.polyfill();
sentryUtils.init();
highchartsUtils.init();
ZendeskUtils.init();

api.registerStore(store);
api.registerSessionTimeoutAction(sessionTimeout);
api.registerHistory(history);

const renderApp = () => (
  <Provider store={store}>
    <IntlProvider>
      <IntlGlobalProvider>
        <HtmlLangSync />
        <DndProvider backend={HTML5Backend}>
          <ConnectedRouter history={history}>
            <App />
            <CustomDragLayer />
            <Toaster />
          </ConnectedRouter>
        </DndProvider>
      </IntlGlobalProvider>
    </IntlProvider>
  </Provider>
);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(renderApp());
